import OBase from './OBase';

import * as Geometry from '../geometry';

export default class SortList extends OBase {
  update () {
    let kInputTree = this.getFloatInput('Keys');
    let aInputTree = this.getObjectInput('Values A');

    let kOutput = this.getGenericObjectOutput('Keys');
    let aOutput = this.getGenericObjectOutput('Values A');

    let dataTrees = [];
    let outDataTrees = [];
    dataTrees.push(kInputTree, aInputTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let kOutTree = new Geometry.DataTree();
    let aOutTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      let keys = [];
      let values = [];

      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let key = parseFloat(outDataTrees[0].branches[i][j]);
        let value = outDataTrees[1].branches[i][j];
        if (keys.includes(key)) {
          throw new Error(`All keys must be different in SortList`);
        }
        keys.push(key);
        values.push(value);
      }

      const path = outDataTrees[0].paths[i];

      let pairs = values.map((v, i) => {
        return {
          key: keys[i],
          value: v
        };
      });

      // ascending
      let ordered = pairs.sort((a, b) => {
        return a.key - b.key;
      });

      ordered.forEach((pair, idx) => {
        kOutTree.add(pair.key, path, true);
        aOutTree.add(pair.value, path, true);
      });
    }

    kOutput.value = kOutTree;
    aOutput.value = aOutTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/SortList.js